import { render } from "./TagBubble.vue?vue&type=template&id=365a4aab&scoped=true"
import script from "./TagBubble.vue?vue&type=script&lang=js"
export * from "./TagBubble.vue?vue&type=script&lang=js"

import "./TagBubble.vue?vue&type=style&index=0&id=365a4aab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365a4aab"]])

export default __exports__